import { css } from "@linaria/core";

export const externalLinkIcon = css`
  margin-top: -0.4rem;
  margin-left: 1rem;

  height: 1.4rem;
`;
